/**
 * Web Style Import
 *
 */

import './dnb-stat.scss'
